"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRemovePrintablesFromPrintableGroup = void 0;
const typeguard_1 = require("../types/typeguard");
const ProjectAction_1 = require("./ProjectAction");
const RemovePrintablesFromPrintableGroupRuleSet = {
  type: value => value === 'REMOVE_PRINTABLES_FROM_PRINTABLE_GROUP',
  printableIds: value => (0, typeguard_1.isArray)(value) && value.every(typeguard_1.isNonEmptyString)
};
const isRemovePrintablesFromPrintableGroup = p => {
  return (0, ProjectAction_1.isBaseProjectAction)(p) && p && (0, typeguard_1.isType)(p, RemovePrintablesFromPrintableGroupRuleSet);
};
exports.isRemovePrintablesFromPrintableGroup = isRemovePrintablesFromPrintableGroup;